import { createContext, useContext } from "react";
const FormContext = /*#__PURE__*/ createContext(void 0);
const FormContextProvider = FormContext.Provider;
const useFormContext = ()=>useContext(FormContext);
export { FormContextProvider, useFormContext };
